import '../lib/sentry'

import * as Turbo from '@hotwired/turbo'
Turbo.start()

import '../controllers'
